import {
  getDocs,
  query,
  collectionGroup,
} from 'firebase/firestore'
import logger from '@common/src/lib/logger'
import { db, getDbForRegion } from '@pulse/firebase/firebaseapi'
import { COLLECTIONS } from '../../constants/constants'

/**
 * All stores of a region (default: the region this page load runs in).
 * @param {string} [regionKey] - e.g. 'home' | 'uk' — used by the Users form to list the chosen region's stores.
 */
export const getStore = async (regionKey) => {
  try {
    let snap

    const storesQuery = query(collectionGroup(regionKey ? getDbForRegion(regionKey) : db, COLLECTIONS.STORES));
    snap = await getDocs(storesQuery)

    // Map the documents to the desired format
    const data = snap.docs.map((doc) => ({
      value: doc?.id,
      label: (doc?.data()?.name?.en || '') + ' ' + (doc?.data()?.address?.city?.en || '') || doc?.data()?.outletCode || '',
      companyId: doc.ref.path.split('/')[1], // Extract `companyId` from the path
    }));
    return data
  } catch (error) {
    logger.error('Error fetching Store data:', error)
    return [] // Return an empty array in case of error
  }
}
